import React, { useState, useEffect } from "react";
import "./admin_home.css";
import Sidebar from "../../Components/3rd page(Dashboard)/sidebar";
import { Line } from "react-chartjs-2";
import logo from "../../Assets/EMEI logo.jpeg";
import admin_img from "../../Assets/dadaa.jpg";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
  Filler,
} from "chart.js";
// ✅ STEP 1: define plugin FIRST
const verticalLinePlugin = {
  id: "verticalLine",
  afterDraw: (chart) => {
    const { ctx, tooltip, chartArea } = chart;

    if (tooltip && tooltip.getActiveElements().length > 0) {
      const x = tooltip.getActiveElements()[0].element.x;

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, chartArea.top);
      ctx.lineTo(x, chartArea.bottom);

      ctx.setLineDash([5, 5]);
      ctx.strokeStyle = "#94a3b8";
      ctx.lineWidth = 1;

      ctx.stroke();
      ctx.restore();
    }
  },
};

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
  Filler,
  verticalLinePlugin,
);
ChartJS.defaults.elements.line.borderWidth = 2;
ChartJS.defaults.scale.grid.borderDash = [5, 5];

export default function AdminHome() {
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,

    interaction: {
      mode: "index",
      intersect: false,
    },

    animation: {
      duration: 1200,
      easing: "easeInOutCubic", // 🔥 smooth curve draw
    },

    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "#fff",
        titleColor: "#000",
        bodyColor: "#000",
        borderColor: "#e2e8f0",
        borderWidth: 1,
      },
    },

    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#64748b" },
      },

      y: {
        min: 0,
        max: 40,

        grid: {
          borderDash: [5, 5],
          // Optional: specific color to make them subtle
          color: "rgba(0, 0, 0, 0.1)",
        },

        ticks: {
          stepSize: 10,
          color: "#64748b",
          callback: (v) => v + "k",

          // Ensures your 10k-40k labels are present
        },
      },
    },
  };

  // ================= STATE =================
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [yearData, setYearData] = useState({});

  // ================= DATE HELPERS =================
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  // ================= NAVIGATION =================
  const handlePrev = () => {
    const newDate = new Date(year, month - 1, 1);
    setCurrentDate(newDate);
  };

  const handleNext = () => {
    const newDate = new Date(year, month + 1, 1);
    setCurrentDate(newDate);
  };

  // ================= DATA GENERATION =================
  const generateYearData = (year) => {
    const data = {};

    for (let m = 0; m < 12; m++) {
      const days = new Date(year, m + 1, 0).getDate();

      data[m] = Array.from({ length: days }, (_, d) => {
        const wave = Math.sin((d / days) * Math.PI * 2); // 🔥 variation
        const base = 4000 + wave * 2000;

        return {
          sales: Math.floor(base + Math.random() * 1500),
          expenses: Math.floor(base * 0.6 + Math.random() * 1000),
        };
      });
    }

    return data;
  };

  useEffect(() => {
    setYearData(generateYearData(selectedYear));
  }, [selectedYear]);

  // ================= YEARLY CHART =================
  const monthlySales = [];
  const monthlyExpenses = [];

  for (let m = 0; m < 12; m++) {
    const arr = yearData[m] || [];

    const totalSales = arr.reduce((a, b) => a + (b?.sales || 0), 0);
    const totalExpenses = arr.reduce((a, b) => a + (b?.expenses || 0), 0);

    monthlySales.push(Math.round(totalSales / 1000));
    monthlyExpenses.push(Math.round(totalExpenses / 1000));
  }
  function createGradient(ctx, chartArea) {
    const gradient = ctx.createLinearGradient(
      chartArea.left,
      0,
      chartArea.right,
      0,
    );

    // Your exact stops and colors
    gradient.addColorStop(0, "#004280"); // 0%
    gradient.addColorStop(0.8894, "#008645"); // 88.94%
    gradient.addColorStop(1, "#008F3E"); // 100%

    return gradient;
  }
  function createExpensesGradient(ctx, chartArea) {
    // Creates a horizontal gradient from left to right of the chart area
    const gradient = ctx.createLinearGradient(
      chartArea.left,
      0,
      chartArea.right,
      0,
    );

    // Exact RGBA colors and percentage stops provided
    gradient.addColorStop(0, "rgba(0, 66, 128, 0.4)"); // 0%
    gradient.addColorStop(0.8894, "rgba(0, 134, 69, 0.4)"); // 88.94%
    gradient.addColorStop(1, "rgba(0, 143, 62, 0.4)"); // 100%

    return gradient;
  }
  const earningData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Sales",
        data: [5, 12, 19, 7, 16, 25, 32, 34, 40, 27, 30, 36], // 🔥 tuned like your UI
        borderColor: function (context) {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null;
          }
          return createGradient(ctx, chartArea);
        },
        borderWidth: 3,
        tension: 0.45,
        pointRadius: 0,

        fill: false, // ❌ REMOVE heavy fill
      },
      {
        label: "Expenses",
        data: [4, 10, 6, 12, 9, 10, 16, 14, 28, 18, 25, 27],
        borderColor: function (context) {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            // This prevents errors during the initial render
            return null;
          }
          return createExpensesGradient(ctx, chartArea);
        },
        borderWidth: 3,
        tension: 0.45,
        pointRadius: 0,

        fill: false,
      },
    ],
  };
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  // ================= DAILY (CALENDAR LINKED) =================
  const monthArr = yearData[month] || [];

  // split into 4 proper weeks (always 7 days)
  const [selectedWeek, setSelectedWeek] = useState(0);
  const weeks = [
    monthArr.slice(0, 7),
    monthArr.slice(7, 14),
    monthArr.slice(14, 21),
    monthArr.slice(21, 28),
  ];

  // ensure selected week always has 7 values
  const currentWeekData = Array.from({ length: 7 }, (_, i) => {
    return weeks[selectedWeek]?.[i] || { sales: 0 };
  });

  const salesData = {
    labels: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    datasets: [
      {
        label: "Sales",
        data: currentWeekData.map((d) => d.sales / 1000),

        borderColor: "#0f7b4f",
        tension: 0.45,

        // 🔥 dynamic point size
        pointRadius: (ctx) => (ctx.dataIndex === selectedDate.getDay() ? 6 : 4),

        // 🔥 highlight selected day
        pointBackgroundColor: (ctx) =>
          ctx.dataIndex === selectedDate.getDay() ? "#ef4444" : "#0f7b4f",
      },
    ],
  };
  useEffect(() => {
    const newWeek = Math.floor((selectedDate.getDate() - 1) / 7);
    setSelectedWeek(newWeek);
  }, [selectedDate]);
  // ================= TOTAL =================
  const totalEarnings = monthlySales.reduce((a, b) => a + b, 0);
  const [collapsed, setCollapsed] = useState(false);
  useEffect(() => {
    const week = Math.floor((selectedDate.getDate() - 1) / 7);
    setSelectedWeek(week);
  }, [selectedDate]);
  // Adding holidays  inside your array used in calender
  const holidaysByMonth = {
    0: [
      // January
      { day: 1, name: "New Year" },
      { day: 26, name: "Republic Day" },
    ],

    1: [
      // February
      { day: 14, name: "Valentine's Day" },
    ],

    2: [
      // March
      { day: 8, name: "Holi" },
      { day: 25, name: "Good Friday" },
    ],

    3: [
      // April
      { day: 14, name: "Ambedkar Jayanti" },
      { day: 21, name: "Ram Navami" },
    ],

    4: [
      // May
      { day: 1, name: "Labour Day" },
    ],

    5: [
      // June
      { day: 17, name: "Eid al-Adha" },
    ],

    6: [
      // July
      { day: 21, name: "Guru Purnima" },
    ],

    7: [
      // August
      { day: 15, name: "Independence Day" },
      { day: 19, name: "Raksha Bandhan" },
    ],

    8: [
      // September
      { day: 7, name: "Ganesh Chaturthi" },
    ],

    9: [
      // October
      { day: 2, name: "Gandhi Jayanti" },
      { day: 12, name: "Dussehra" },
    ],

    10: [
      // November
      { day: 1, name: "Diwali" },
      { day: 15, name: "Bhai Dooj" },
    ],

    11: [
      // December
      { day: 25, name: "Christmas" },
    ],
  };
  const holidays = holidaysByMonth[month] || [];
  <div className={`admin_sidebar ${collapsed ? "collapsed" : ""}`}>
    {/* TOGGLE BUTTON */}
    <div className="admin_toggle" onClick={() => setCollapsed(!collapsed)}>
      {collapsed ? "›" : "‹"}
    </div>

 
  </div>;
  return (
    <div>
<div className={`admin_container ${collapsed ? "collapsed" : ""}`}>
        {/* SIDEBAR */} <div>
  <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
  
            {/* TOGGLE BUTTON */}


  
        </div>

        {/* MAIN */}
        <div className="admin_main">
          {/* HEADER */}
          <div className="admin_header">
            <div className="admin_header_text">
              <h2>Dashboard</h2>
              <p>Overview of Your Platform Statistics</p>
            </div>

            <div className="admin_header_actions">
              <div className="admin_notification">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                </svg>
                <span className="notification_dot"></span>
              </div>

              <button className="admin_btn">
                View Analytics <span className="arrow">↗</span>
              </button>
            </div>
          </div>

          {/* CARDS */}
          <div class="admin_cards">
            <div class="admin_card">
              <div class="content">
                <p>Total Students</p>
                <h3>5000+</h3>
              </div>
              <div class="icon-container">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
            </div>

            <div class="admin_card">
              <div class="content">
                <p>Total Courses</p>
                <h3>1000+</h3>
              </div>
              <div class="icon-container">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                </svg>
              </div>
            </div>

            <div class="admin_card">
              <div class="content">
                <p>Total Sales</p>
                <h3>50.2k+</h3>
              </div>
              <div class="icon-container">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="12" y1="1" x2="12" y2="23"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
              </div>
            </div>

            <div class="admin_card">
              <div class="content">
                <p>Total Earnings</p>
                <h3>8.23 Lacs</h3>
              </div>
              <div class="icon-container">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                </svg>
              </div>
            </div>
          </div>

          {/* CONTENT */}
          <div className="admin_content">
            {/* LEFT */}
            <div className="admin_left">
              <div className="admin_chartBox">
                {/* TOP STRIP */}
                <div className="admin_topStrip">
                  <div className="admin_badge">
                    <div className="flex11">
                      {" "}
                      <p>Total Earnings :</p>
                      <h2>₹{totalEarnings.toLocaleString()}</h2>
                    </div>
                    {/* BADGE */}
                    <div className="admin_profitLine">
                      <span className="dot"></span>
                      <span className="dot_percent">30%</span>
                      <label className="dot_p"> Profit Increases</label>
                    </div>
                  </div>
                  <div className="admin_year_wrapper">
                    <select
                      className="admin_year"
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(Number(e.target.value))}
                    >
                      {[2024, 2025, 2026, 2027].map((y) => (
                        <option key={y} value={y} className="year_option">
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* LEGEND */}
                <div className="admin_legendRow">
                  <span>
                    <i className="sales"></i> Sales
                  </span>
                  <span>
                    <i className="expense"></i> Expenses
                  </span>
                </div>

                {/* CHART */}
                <div className="admin_chartWrapper">
                  <Line
                    data={earningData}
                    options={chartOptions}
                    redraw={true}
                  />{" "}
                </div>
              </div>

              <div className="admin_chartBox">
                <div className="admin_topStrip">
                  {/* HEADER ROW */}
                  <div className="admin_chartHeader">
<div className="flex12">
                      <h3>Daily Sales</h3>

                    <div className="admin_dprofitLine">
                      <span className="daily_dot"></span>
                      <span className="dailydot_percent">50%</span>
                      <label className="dailydot_p"> Profit Increases</label>
                    </div>
</div>
<div className="select_wrapper">

                      <select
                      className="admin_week_select"
                      value={selectedWeek}
                      onChange={(e) => setSelectedWeek(Number(e.target.value))}
                    >
                      <option value={0}>Week 1</option>
                      <option value={1}>Week 2</option>
                      <option value={2}>Week 3</option>
                      <option value={3}>Week 4</option>
                    </select>
</div>

                  </div>
                </div>

                {/* CHART */}
                <div className="admin_chartWrapper">
                  <Line data={salesData} options={chartOptions} />
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <div className="admin_right">
              {/* CALENDAR */}
              <div className="admin_calendar">
                <div className="admin_calendarHeader">
                  <button className="nav_btn" onClick={handlePrev}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M15 18l-6-6 6-6" />
                    </svg>
                  </button>
                  <h4 className="calendar_title">{monthNames[month]}</h4>
                  <button className="nav_btn" onClick={handleNext}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                </div>

                <div className="admin_weekdays">
                  {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((d) => (
                    <span key={d}>{d}</span>
                  ))}
                </div>

                <div className="admin_days">
                  {/* Empty spans for padding start of month */}
                  {[...Array((firstDay + 6) % 7)].map((_, i) => (
                    <span key={i}></span>
                  ))}

                  {/* Actual days of the month */}
                  {[...Array(daysInMonth)].map((_, i) => {
                    const day = i + 1;

                    // Logic to find the day of the week (0=Mon, 6=Sun)
                    const dayOfWeek = (i + ((firstDay + 6) % 7)) % 7;
                    const isWeekend = dayOfWeek === 5 || dayOfWeek === 6; // 5 is Sa, 6 is Su
                    const isHoliday = holidays.some((h) => h.day === day);
                    const holidayName = holidays.find(
                      (h) => h.day === day,
                    )?.name;
                    return (
                      <span
                        key={day}
                        className={`
    ${day === selectedDate.getDate() ? "active" : ""} 
    ${isWeekend || isHoliday ? "highlight_blue" : ""}
  `}
                        onClick={() =>
                          setSelectedDate(new Date(year, month, day))
                        }
                      >
                        {day}
                      </span>
                    );
                  })}
                </div>
              </div>

              {/* COURSES */}
              <div className="admin_courses">
                <h4>Popular Courses</h4>

                {/* Course 1 */}
                <div className="admin_course">
                  <div className="admin_thumb"></div>
                  <div className="admin_course_info">
                    <p>Learn the Java Programming</p>
                    <div className="admin_rating">
                      <span className="rating_score">
                        4.7 <span className="star">★</span>
                      </span>
                      <span className="rating_max">out of 5</span>
                    </div>
                  </div>
                </div>

                {/* Course 2 */}
                <div className="admin_course">
                  <div className="admin_thumb"></div>
                  <div className="admin_course_info">
                    <p>Fundamentals of Python</p>
                    <div className="admin_rating">
                      <span className="rating_score">
                        4.2 <span className="star">★</span>
                      </span>
                      <span className="rating_max">out of 5</span>
                    </div>
                  </div>
                </div>

                {/* Course 3 (Optional extra from image) */}
                <div className="admin_course">
                  <div className="admin_thumb"></div>
                  <div className="admin_course_info">
                    <p>Fundamentals of Python</p>
                    <div className="admin_rating">
                      <span className="rating_score">
                        4.2 <span className="star">★</span>
                      </span>
                      <span className="rating_max">out of 5</span>
                    </div>
                  </div>
                </div>

                <button className="admin_courseBtn">
                  Course Statistics <span className="arrow">→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
